"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POKER_DECKS = void 0;
exports.POKER_DECKS = {
    tshirt: ["?", "XS", "S", "M", "L", "XL", "XXL"],
    standard: ["?", "1", "2", "4", "8", "16", "24", "32"],
};
//# sourceMappingURL=poker.types.js.map